{
  "files": [
    "colors.raw.json",
    "transparent-colors.raw.json",
    "palettes.raw.json",
    "font.raw.json",
    "hooks.raw.json",
    "radius.raw.json",
    "ratio.raw.json",
    "shadow.raw.json",
    "sizing.raw.json",
    "spacing.raw.json"
  ],
  "categories": {
    "system-color": {
      "name": "system-color",
      "type": "color",
      "label": "System Colors",
      "description": "System level styling hooks would provide a way to manage the visual appearance of elements across an entire application.",
      "groups": [
        "theme",
        "feedback",
        "borders",
        "links"
      ]
    },
    "reference-color": {
      "name": "reference-color",
      "type": "color",
      "label": "Palette Colors",
      "description": "Generic colors to use within a Salesforce application.",
      "groups": [
        "reference"
      ]
    }
  }
}
